/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CustomerSegmentModel from 'cio/models/customer-segment';

interface CioPersonSegmentsListArgs {
  segments: CustomerSegmentModel[];
  type: 'belongs' | 'others';
}

export default class CioPersonSegmentsList extends Component<CioPersonSegmentsListArgs> {}
